import React, { Fragment, useEffect, useMemo, useState } from "react";
import * as Yup from "yup";
import yupSchema from "../../../constants/schema";
import { useErrorHandler } from "../../../hooks";
import glassesService from "../../../services/glasses.service";
import DialogFormBuilder from "../../../components/dialog-form-builder";
import { useSelector } from "react-redux";
import { DialogContent, Grid } from "@material-ui/core";

const initialValues = {
    name: "",
    summery: "",
    description: "",
    weight: "",
    // price: 0,
    gender: undefined,
    material: undefined,

    shape: undefined,
    faceTypes: [],
    specialFeatures: [],
    brandId: undefined,
    isActive: true,
};
const schema = Yup.object().shape({
    name: yupSchema.name,
    summery: yupSchema.summery,
    description: yupSchema.description,
    weight: yupSchema.weight,
    gender: yupSchema.gender,
    category: yupSchema.type,
    material: yupSchema.material,
    lensMaterial: yupSchema.lensMaterial,
    shape: yupSchema.shape,
    faceTypes: yupSchema.faceTypes,
    specialFeatures: yupSchema.specialFeatures,
    brandId: yupSchema.brandId,
    // TODO: schema
});

const FormWrapper = ({ children }) => (
    <DialogContent>
        <Grid container spacing={2}>
            {children}
        </Grid>
    </DialogContent>
);

export default function FormModalContent({ close, data, extra }) {
    const errorHandler = useErrorHandler();
    const { initials } = useSelector((state) => state.app);

    if(data){
        data.specialFeatures = data?.specialFeatures?.map(item => item?.id) || []
    }

    const form = useMemo(
        () => [
            {
                _type: "container",
                name: "col1",
                _wrapper: (props) => <Grid item sm={7} md={6} xs={12} {...props} />,
                form: [
                    {
                        _type: "textField",
                        name: "name",
                        label: "نام",
                        autoFocus: true,
                    },
                    {
                        _type: "textField",
                        name: "summery",
                        label: "خلاصه توضیحات",
                        multiline: true,
                        rows: 5,
                    },
                    {
                        _type: "textField",
                        name: "description",
                        label: "توضیحات",
                        multiline: true,
                        rows: 9,
                    },
                    {
                        _type: "textField",
                        name: "weight",
                        type: "number",
                        label: "وزن",
                        inputProps: {
                            min: 0,
                        },
                    },
                    {
                        _type: "textField",
                        name: "bridge",
                        type: "number",
                        label: "پل",
                        inputProps: {
                            min: 0,
                            max: 3,
                        },
                    },
                    {
                        _type: "datePicker",
                        disabled: !data?.id,
                        name: "createDate",
                        label: "زمان ایجاد",
                    },
                ],
            },
            {
                _type: "container",
                name: "col2",
                _wrapper: (props) => <Grid item sm={5} md={6} xs={12} {...props} />,
                form: ({ setFieldValue }) => [
                    {
                        _type: "autocomplete",
                        _empty: undefined,
                        name: "category",
                        options: initials?.enums?.glassCategory || [],
                        label: "نوع",
                        disableClearable: true,
                        valueSelector: "value",
                        labelSelector: "title",
                    },
                    {
                        _type: "autocomplete",
                        _empty: undefined,
                        name: "gender",
                        options: initials?.enums?.gender || [],
                        label: "جنسیت",
                        disableClearable: true,
                        valueSelector: "value",
                        labelSelector: "title",
                    },
                    {
                        _type: "autocomplete",
                        _empty: undefined,
                        name: "material",
                        options: initials?.enums?.material || [],
                        label: "جنس",
                        disableClearable: true,
                        valueSelector: "value",
                        labelSelector: "title",
                    },
                    {
                        _type: "autocomplete",
                        _empty: undefined,
                        name: "lensMaterial",
                        options: initials?.enums?.lensMaterial || [],
                        label: "جنس عدسی",
                        disableClearable: true,
                        valueSelector: "value",
                        labelSelector: "title",
                    },
                    {
                        _type: "autocomplete",
                        _empty: undefined,
                        name: "shape",
                        options: initials?.enums?.shape || [],
                        label: "شکل",
                        disableClearable: true,
                        valueSelector: "value",
                        labelSelector: "title",
                        onChange: ({ value }) => {
                            const faceTypes = initials?.glassShapeFaceTypes?.[value];
                            if (faceTypes) setFieldValue("faceTypes", faceTypes);
                        },
                    },
                    {
                        _type: "autocomplete",
                        _empty: undefined,
                        name: "faceTypes",
                        options: initials?.enums?.faceTypes || [],
                        label: "تایپ صورت",
                        disableClearable: true,
                        multiple: true,
                        valueSelector: "value",
                        labelSelector: "title",
                        fast: false,
                    },
                    {
                        _type: "autocomplete",
                        _empty: undefined,
                        name: "specialFeatures",
                        options: initials?.specialFeatures || [],
                        label: "ویژگی خاص",
                        disableClearable: true,
                        multiple: true,
                        valueSelector: "id",
                        labelSelector: "name",
                        fast: false,
                    },
                    {
                        _type: "autocomplete",
                        _empty: undefined,
                        name: "brandId",
                        options: extra?.brands || [],
                        label: "برند",
                        disableClearable: true,
                        valueSelector: "id",
                        labelSelector: "name",
                    },
                    {
                        _type: "autocomplete",
                        _empty: undefined,
                        name: "search_keys",
                        options: [],
                        label: "هم خانواده",
                        disableClearable: true,
                        multiple: true,
                        valueSelector: "value",
                        labelSelector: "title",
                        fast: false,
                    },
                    {
                        _type: "switch",
                        name: "isActive",
                        label: "فعال",
                    },
                ],
            },
        ],
        [initials, extra]
    );

    const handleSubmit = async (model, { setSubmitting }) => {
        let op;
        if (data?.id) {
            op = await glassesService.editGlasses(data.id, model);
        } else {
            op = await glassesService.createGlasses(model);
        }

        const { error } = op;
        setSubmitting(false);
        if (error) return errorHandler(error);

        close(true);
    };

    return (
        <DialogFormBuilder
            {...{
                close,
                name: "عینک",
                data,
                schema,
                initialValues,
                handleSubmit,
                form,
                formWrapper: FormWrapper,
            }}
        />
    );
}
